export default __webpack_public_path__ + "static/media/imgSpinEn.69bf5706.png";